module.exports = __webpack_public_path__ + "img/arrow_next.586e5870.svg";